import { createSelector } from '@ngrx/store';

import { fileUploadFeatureKey } from '@shared/reducers/file-upload.reducer';
import { selectCoreModule } from '@shared/selectors/core.selector';

const selectFileUploadState = createSelector(selectCoreModule, coreState => coreState[fileUploadFeatureKey]);

/**
 * select uploaded file params
 */
export const selectUploadedFileParams = createSelector(
  selectFileUploadState,
  fileUploadState => fileUploadState?.uploadedFileItem
);

/**
 * select file to upload loading
 */
export const selectFileToUploadLoading = createSelector(
  selectFileUploadState,
  fileUploadState => fileUploadState.fileToUploadLoading
);

/**
 * select delete status
 */
export const selectDeleteStatus = createSelector(
  selectFileUploadState,
  fileUploadState => fileUploadState.deleteStatus
);
